import { create } from 'zustand';
import { DEFAULT_NOTIFICATIONS_DELAY } from '@helper/constants';

export const useSnackbarStore = create((set) => ({
  isOpen: false,
  message: '',
  type: 'success',
  delay: DEFAULT_NOTIFICATIONS_DELAY,
  handleSuccess: (message, delay=DEFAULT_NOTIFICATIONS_DELAY) => set({ isOpen: true, message, type: 'success', delay }),
  handleError: (message, delay=DEFAULT_NOTIFICATIONS_DELAY) => set({ isOpen: true, message, type: 'error', delay }),
  handleThankYou: (message, delay=DEFAULT_NOTIFICATIONS_DELAY) => set({ isOpen: true, message, type: 'thanks', delay }),
  handleClose: () => set({ isOpen: false }),
}));
